/* eslint-disable no-mixed-operators */
/* eslint-disable no-unused-vars */
import $ from 'jquery';
import rangeslider from 'rangeslider.js';

function updateTooltip(pos, inputValue, context) {
    const value = inputValue || context.value;
    const $tooltip = $('.rangeslider__tooltip', context.$range);
    if ($tooltip.length) {
        if (context.$element.data('for') === 'amount') {
            $tooltip[0].innerHTML = `$${String(value).replace(/\d(?=(?:\d{3})+$)/g, '$&,')}`;
        } else if (context.$element.data('for') === 'years') {
            $tooltip[0].innerHTML = `Over ${value} years`;
        } else {
            $tooltip[0].innerHTML = value;
        }
    }
}

function getReturns(amount, years, generic = true) {
    const GROWTH_RATE = 1.07;

    return Math.ceil(
        Array.from(Array(years))
            .reduce((total, _) => {
                let costs;
                if (generic) {
                    costs = 0.025;
                } else if (total >= 10000 && total < 200000) {
                    costs = 0.0075;
                } else if (total >= 200000 && total < 500000) {
                    costs = 0.0065;
                } else if (total >= 500000) {
                    costs = 0.0055;
                }
                return (total * GROWTH_RATE) - ((total + (total * GROWTH_RATE)) / 2 * costs);
            }, amount),
    );
}

function updateGraph(inputYears, sixparkReturns, $outputYears, scale) {
    $outputYears.text(inputYears);
    const max = inputYears >= 100000 ? Math.floor(sixparkReturns / 100000) * 100000 : Math.floor(sixparkReturns / 10000) * 10000;
    $(scale[0]).text(`$${max}`.replace(/\d(?=(?:\d{3})+$)/g, '$&,'));
    $(scale[1]).text(`$${max / 4 * 3}`.replace(/\d(?=(?:\d{3})+$)/g, '$&,'));
    $(scale[2]).text(`$${max / 4 * 2}`.replace(/\d(?=(?:\d{3})+$)/g, '$&,'));
    $(scale[3]).text(`$${max / 4}`.replace(/\d(?=(?:\d{3})+$)/g, '$&,'));
}

function updateReturns(inputAmount, inputYears, $outputYears, scale, ...outputs) {
    const sixparkReturns = getReturns(inputAmount, inputYears, false);
    const genericReturns = getReturns(inputAmount, inputYears);

    outputs.forEach(($output) => {
        switch ($output.data('for')) {
        case 'sixpark':
            $output.text(`$${sixparkReturns}`.replace(/\d(?=(?:\d{3})+$)/g, '$&,'));
            break;
        default:
            $output.text(`$${genericReturns}`.replace(/\d(?=(?:\d{3})+$)/g, '$&,'));
        }
    });

    updateGraph(inputYears, sixparkReturns, $outputYears, scale);
}

function init(container) {
    const $container = $(container);
    const $outputSixpark = $container.find('[data-for="sixpark"]');
    const $outputGeneric = $container.find('[data-for="generic"]');
    const $outputYears = $('[data-output="years"]');
    const $inputAmount = $container.find('[data-for="amount"]');
    const $inputYears = $container.find('[data-for="years"]');
    const scale = $container.find('[data-scale]');

    $container.find('input[type="range"]').rangeslider({
        polyfill: false,
        onInit() {
            const tooltip = '<div class="rangeslider__tooltip"></div>';
            this.$handle.append($(tooltip));
            updateTooltip(null, null, this);
            updateReturns(Number($inputAmount.val()), Number($inputYears.val()), $outputYears, scale, $outputSixpark, $outputGeneric);
        },
        onSlide(pos, value) {
            updateTooltip(pos, value, this);
            updateReturns(Number($inputAmount.val()), Number($inputYears.val()), $outputYears, scale, $outputSixpark, $outputGeneric);
        },
    });
}

const containers = Array.from(document.querySelectorAll('.js-calculator'));
containers.forEach(container => init(container));



// WEBPACK FOOTER //
// ./app/scripts/components/calculator.js